import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  useAssignSSOMutation,
  useLazyGetSSOQuery,
} from "../../../features/api/admin/authApi";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import { jwtDecode } from "jwt-decode";
import { actions as appActions } from "../../../app/appSlice";
import { useDispatch } from "react-redux";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import { Checkbox, FormControlLabel } from "@mui/material";
import { t } from "i18next";
import { toast } from "react-toastify";

const LoginPageSSO = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const [dataRes, setDataRes] = useState();

  const [consentUno, setConsentUno] = useState(false);
  const [consentDue, setConsentDue] = useState(false);
  const [consentTre, setConsentTre] = useState(false);

  // const code = "CODEMANUAL";
  const [triggerGetSSO, { data, isLoading, error }] = useLazyGetSSOQuery({
    skip: !code,
  });
  const [consetTerms] = useAssignSSOMutation();

  useEffect(() => {
    if (data) {
      const jParsedData = JSON.parse(data);
      setDataRes(jParsedData);

      if (jParsedData.consents) {
        const decodeJWT = jwtDecode(jParsedData?.token);
        dispatch(
          appActions.updateAppState({
            accessToken: jParsedData?.token,
            ...decodeJWT,
          })
        );
        handleRedirectService();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleConsentTerms = async () => {
    const toastId = toast.loading(t("Processing"));

    try {
      const body = {
        consent1: consentUno,
        consent2: consentDue,
        consent3: consentTre,
      };

      const responseConsentTerms = await consetTerms({
        consents: body,
        token: dataRes?.token,
      });

      if (responseConsentTerms.data.Result !== 1) {
        toast.update(toastId, {
          render: responseConsentTerms.data.Exception || t("NotConsentTerms"),
          type: "error",
          isLoading: false,
          autoClose: 1500,
        });
        return;
      }

      toast.update(toastId, {
        render: `${t("ConsentTerms")}`,
        type: "success",
        isLoading: false,
        autoClose: 1500,
      });

      const JWT = responseConsentTerms.data.Data.updatedJwt;
      setTimeout(() => {
        const decodeJWT = jwtDecode(JWT);
        dispatch(
          appActions.updateAppState({
            accessToken: JWT,
            ...decodeJWT,
          })
        );
        handleRedirectService();
      }, 1500);
    } catch (error) {
      console.error(error);
      toast.update(toastId, {
        render: t("NotConsentTerms"),
        type: "error",
        isLoading: false,
        autoClose: 1500,
      });
    }
  };

  const handleRedirectService = () => {
    setTimeout(() => {
      navigate(`/auth/user/${t("services")}`);
      window.location.reload();
    }, 1000);
  };

  if (isLoading)
    return (
      <div
        className="p-8 w-full flex justify-center items-center"
        style={{ minHeight: "20rem" }}
      >
        <CoreSpinner />
      </div>
    );
  if (error) {
    toast.error("Errore nella verifica");
  }

  return (
    <div className="p-8" style={{ minHeight: "20rem" }}>
      <h2 className="text-center">Redirect Login</h2>
      {dataRes?.consents === false && (
        <div className="w-full flex flex-col justify-start mt-5">
          <FormControlLabel
            className="pt-3"
            required
            label={t("Consent1")}
            control={
              <Checkbox
                checked={consentUno}
                onChange={() => setConsentUno(!consentUno)}
              />
            }
          />

          <FormControlLabel
            className="pt-3"
            required
            label={t("Consent2")}
            control={
              <Checkbox
                checked={consentDue}
                onChange={() => setConsentDue(!consentDue)}
              />
            }
          />

          <FormControlLabel
            className="pt-3"
            required
            label={t("Consent3")}
            control={
              <Checkbox
                checked={consentTre}
                onChange={() => setConsentTre(!consentTre)}
              />
            }
          />
        </div>
      )}
      <div className="mt-20 w-full flex justify-around">
        {dataRes?.consents === false ? (
          <CoreButton
            disabled={!(consentUno && consentDue && consentTre)}
            onClick={handleConsentTerms}
            className="btn-round"
            testo={t("Consensus")}
          />
        ) : (
          <CoreButton
            disabled={!code}
            onClick={() => triggerGetSSO({ code })}
            className="btn-round"
            testo={t("Verifica")}
          />
        )}
      </div>
    </div>
  );
};

export default LoginPageSSO;
